var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixedOnPageTop",class:{
	  modalShowed: _vm.modalShowed ? true : false,
	},attrs:{"id":"maincontent"}},[_vm._t("content",function(){return [_vm._v("   ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }